import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { CurrentUserService } from '../../../security/current-user.service';
import { FormFieldCascadingDropdownConstraintFromMDS } from '../../../shared/models/form-builder/field-constraints/field-cascading-dropdown-constraint.model';
import { CurrentSiteService } from '../../../shared/services/current-site.service';


export class ConstraintFromMdsDialogModel {
    constructor() { }
    public fieldId: number;
    public constraintId: number;
    public constraintType: string;
    public name: string;
    public mdsScheduleTime: number;
    public mdsCommunityPage: string;
    public mdsAttachmentName: string;
    public cadence: string;
}

@Component({
    selector: 'app-constraint-from-mds-dialog',
    standalone: false,
    templateUrl: './constraint-from-mds-dialog.component.html',
    styleUrl: './constraint-from-mds-dialog.component.scss'
})
export class ConstraintFromMdsDialog implements OnInit {
    // Properties.
    public mdsConstraintName: string = "";
    public mdsFieldId: number = 0;
    public mdsCommunityPage: string = "OMBCOLLECT";
    public mdsAttachmentName: string = "State_City.XLSX";
    //public mdsCommunityPage: string = "OMBC_CONSTRAINTS";
    //public mdsAttachmentName: string = "AGENCY_CODE_BUREAU_CODE_ACCOUNT_CODE_TAFS_CONSTRAINT.xlsx";
    //public mdsAttachmentName: string = "RPT_CONSTRAINT_DIRECTED_PARK_CONSTRAINT.xlsx";
    public serviceAccountName: string = "S_CVNXT";
    public mdsScheduleTime: number = 22;
    public cadence: string;
    public ifBlank: string;
    public onSuccessNotify: string = "";
    public onFailureNotify: string = this.currentUserService.user.emailAddress;
    private status: string = '';
    private loadStarted: boolean = false;
    public mode: string = "once"; // or scheduled
    public disableScheduleButton: boolean = false;

    // Constructor.
    public constructor(
        public dialogRef: MatDialogRef<ConstraintFromMdsDialog>,
        @Inject(MAT_DIALOG_DATA) public data: ConstraintFromMdsDialogModel,
        private currentUserService: CurrentUserService,
        private currentSiteService: CurrentSiteService,
        private http: HttpClient) {
        this.mdsConstraintName = data.name;
        this.mdsFieldId = data.fieldId;
        this.mdsCommunityPage = data.mdsCommunityPage;
        this.mdsAttachmentName = data.mdsAttachmentName;
        this.cadence = data.cadence;
    }

    // Life cycle methods.
    public ngOnInit(): void {
    }

    public ScheduleLoad(): Promise<any> {
        this.status = 'Scheduling...';
        this.disableScheduleButton = true;
        let baseUrl: string = environment.apiUrl;
        if (!baseUrl.endsWith('/')) baseUrl += '/';
        let url = `${baseUrl}api/FieldConstraint/ScheduleUpdateConstraintFromMDS/${this.data.fieldId}`;
        let constraintVM: FormFieldCascadingDropdownConstraintFromMDS =
            new FormFieldCascadingDropdownConstraintFromMDS(this.currentSiteService.Site.id);
        constraintVM.mdsCommunityPage = this.mdsCommunityPage;
        constraintVM.dataCollectionId = this.currentSiteService.Site.id;
        constraintVM.mdsAttachmentName = this.mdsAttachmentName;
        constraintVM.constraintId = this.data.fieldId;
        constraintVM.name = this.mdsConstraintName;
        constraintVM.constraintType = this.data.constraintType;
        constraintVM.mdsScheduleTime = this.mdsScheduleTime;
        constraintVM.cadence = this.cadence;
        constraintVM.ifBlank = this.ifBlank;
        constraintVM.onFailureNotify = this.onFailureNotify;
        constraintVM.onSuccessNotify = this.onSuccessNotify;

        return this.http.post<string>(url, constraintVM)
            .toPromise()
            .then(response => {
                if (response.toLowerCase().indexOf('failed') >= 0) {
                    this.status = response;
                }
                else {
                    this.status = 'Done: ' + response;
                }
                return response;
            });
    }

    public get LoadOnceDisabled(): boolean {
        return this.loadStarted;
    }

    public LoadOnce(): Promise<any> {
        this.status = 'Loading...';
        this.loadStarted = true;

        let baseUrl: string = environment.apiUrl;
        if (!baseUrl.endsWith('/')) baseUrl += '/';
        let url = `${baseUrl}api/FieldConstraint/UpdateConstraintFromMDS/${this.data.fieldId}`;
        //url = `${baseUrl}/${this.endpoint}/createFolderPermissionExpression/${folderId}`;

        let constraintVM: FormFieldCascadingDropdownConstraintFromMDS =
            new FormFieldCascadingDropdownConstraintFromMDS(this.currentSiteService.Site.id);
        constraintVM.mdsCommunityPage = this.mdsCommunityPage;
        constraintVM.mdsAttachmentName = this.mdsAttachmentName;
        constraintVM.constraintId = this.data.fieldId;
        constraintVM.name = this.mdsConstraintName;
        constraintVM.constraintType = this.data.constraintType;

        return this.http.post<string>(url, constraintVM)
            .toPromise()
            .then(response => {
                if (response.toLowerCase().indexOf('failed') >= 0) {
                    this.status = response;
                }
                else {
                    this.status = 'Complete';
                }
                return response;
            });
    }

    public get DisableNameEdit(): boolean {
        return this.mdsFieldId > 0;
    }

    public get Status() {
        return this.status;
    }
}
